export function Input(props) {
  return <input className="border rounded px-2 py-1 w-full" {...props} />;
}
